export default __webpack_public_path__ + "static/media/sofft.9ea9940c.png";